//
import { API } from "../../api";
async function cancel_basket(request) {
    // console.log("cancel_basket -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/cancel`, //`v2/abandon/baskets`, //
        content: request,
    });
}
export { 
// ICancelBasketRequest,
cancel_basket, };
